import styled from 'styled-components';

import { IconBulb } from '@zillow/constellation';

export const StyledIconBulb = styled(IconBulb)`
  cursor: pointer;
`;
